import { z } from 'zod';
import { DraftNodeEnvelopeSchema } from '../../entities/process-draft';
/**
 * Promote a legacy event input (no `eventId`) into a first-class draft
 * event. Creates the event seeded from the input's `type`/`name`/
 * `description` and wires `step.inputs[inputIndex].eventId` to it. The
 * response envelope carries the new event ROW and the updated step in
 * `nodes`, with the event's `stableStepId` in `createdNodeIds`.
 */ export const upgradeLegacyEventInputContract = {
    method: 'POST',
    path: '/api/v2/process/:processId/draft/steps/:stepId/inputs/:inputIndex/upgrade-event',
    description: 'Promote a legacy event input (no eventId) into a first-class event entity and link them. Used by the frontend to upgrade pre-first-class event inputs on first interaction (delete, reconnect, detach).',
    requestSchema: z.object({}),
    responseSchema: DraftNodeEnvelopeSchema,
    statusCodes: {
        success: 201,
        errors: {
            400: 'Input is not an event input, or already has an eventId',
            401: 'Unauthorized',
            403: 'Forbidden',
            404: 'Draft, step, or input not found'
        }
    }
};

//# sourceMappingURL=upgrade-draft-event-input.contract.js.map